import { Form } from "antd"

import { type AddTryoutFormValues } from "#customTypes/composedTypes/tryoutTypes"
import useTryoutSessionOptions from "#forms/TryoutProgressForm/useTryoutSessionOptions"
import { useGetAllStudents } from "#hooks/jotai/useGetStudents"
import { STANDARD_DATE_FORMAT } from "#utils/dateHelpers"
import { getCurrentSemester } from "#utils/semesterHelpers"
import { getStudentOptions } from "#utils/studentHelpers"

const useTryoutFormData = (initialValues: AddTryoutFormValues | undefined) => {
  const form = Form.useFormInstance()

  // Get student options
  const allStudents = useGetAllStudents()

  const studentOptions = getStudentOptions(allStudents)
  const tryoutOptions = useTryoutSessionOptions(initialValues?.sessionId)

  // Get selected student
  const studentId = Form.useWatch("studentId", form) ?? initialValues?.studentId
  const student =
    allStudents?.find((student) => student.id === studentId) ?? null

  // Use tryout filter date to get semester so we can minimize the number of classes we need to load
  const tryoutFilterDate =
    Form.useWatch("tryoutFilterDate", form) ?? initialValues?.tryoutFilterDate

  const semester = getCurrentSemester(
    tryoutFilterDate?.format(STANDARD_DATE_FORMAT),
    STANDARD_DATE_FORMAT
  )

  return {
    student,
    studentOptions,
    tryoutOptions,
    semester,
  }
}

export default useTryoutFormData
